import { getDataFromAPI } from './servicesClient';

const disclaimerText = async (incentiveObj) =>
  getDataFromAPI('disclaimerText', null, 'POST', incentiveObj).then(
    (response) => ({ response }),
  );
export { disclaimerText };
